const Modal = {
   defaultProps: {
      size: '3xl',
   },
};

export default Modal;
